import { SESSION_DIALOG_IDS, type TSessionDialogDefinition } from '@core/session-dialogs'
import { shouldShowAnniversaryPromo } from '@features/anniversary-promo'
import { shouldShowConverterPromo } from '@features/feature-promos'
import { shouldShowCreatorProfileOffer, shouldShowOldUsersPromo } from '@features/paywall'

export const SESSION_DIALOG_DEFINITIONS: TSessionDialogDefinition[] = [
    {
        id: SESSION_DIALOG_IDS.anniversaryPromo,
        priority: 1,
        shouldShow: shouldShowAnniversaryPromo,
    },
    {
        id: SESSION_DIALOG_IDS.oldUsersPromo,
        priority: 2,
        shouldShow: shouldShowOldUsersPromo,
    },
    {
        id: SESSION_DIALOG_IDS.converterPromo,
        priority: 3,
        shouldShow: shouldShowConverterPromo,
    },
    {
        id: SESSION_DIALOG_IDS.creatorProfileOffer,
        priority: 4,
        shouldShow: shouldShowCreatorProfileOffer,
    },
]
